import React, { useMemo } from 'react'
import { useLayoutDashBoard } from './hook/useLayoutDashBoard';
import { FaHome, FaFile, FaFacebookSquare, FaUser, FaFileContract, FaMoneyBillWave, FaCreditCard, FaBars, FaTimes, FaKey } from 'react-icons/fa';
import { ImExit } from 'react-icons/im';
import { Select } from '../../components/ui/Select'
import ModalSelectNb from '../../context/BenefitSelectedContext';

function LayoutDashBoard({ children, activeMenu }) {
    const {
        navigate,
        setSidebarOpen,
        sidebarOpen,
        handleLogoutClick,
        user,
        benefitSelected,
        setBenefitSelected
    } = useLayoutDashBoard();

    const benefitOptions = useMemo(() => {
        if (!user?.beneficiosProdutos) return [];
        return user.beneficiosProdutos.map(nb => (
            <option key={nb.codigoBeneficio} value={nb.codigoBeneficio}>
                {nb.codigoBeneficio}
            </option>
        ));
    }, [user]);

    return (
        <React.Fragment>
            <ModalSelectNb />
            <div className="flex min-h-screen bg-gray-100">
                {/* Sidebar (Drawer Mobile + Fixed Desktop) */}
                <aside className={`fixed top-0 left-0 h-screen w-64 bg-white text-white flex flex-col justify-between transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 z-50 md:translate-x-0 md:w-48`}>
                    <div>
                        <div className="p-6 flex items-center space-x-2">
                            <img src="/assets/logo-lojao-bmg.png" alt="" />
                        </div>
                        <div className="p-5 block sm:hidden">
                            <Select
                                className='mb-2'
                                onChange={e => setBenefitSelected(e.target.value)}
                                value={benefitSelected}
                                variant='rounded'
                                label={'N° Benefício Selecionado'}
                            >
                                {benefitOptions.map(nb => {
                                    return <option key={nb.codigoBeneficio} value={nb.codigoBeneficio}>{nb.codigoBeneficio}</option>
                                })}
                            </Select>
                        </div>
                        <nav className="mt-10 space-y-4">
                            <button
                                className={`flex items-center px-6 py-2 ${activeMenu === 'Home' ? 'text-[#FA6300]' : 'text-[#462A71]'}`}
                                onClick={() => { navigate('/dashboard'); setSidebarOpen(false); }}
                            >
                                <FaHome className="mr-2 w-5 h-5" /> Home
                            </button>
                            <button
                                className={`flex items-center px-6 py-2 ${activeMenu === 'Contratos' ? 'text-[#FA6300]' : 'text-[#462A71]'}`}
                                onClick={() => { navigate('/dashboard/my-contracts'); setSidebarOpen(false); }}
                            >
                                <FaFileContract className="mr-2 w-5 h-5" /> Contratos
                            </button>
                            <button
                                className={`flex items-center px-6 py-2 ${activeMenu === 'Conta' ? 'text-[#FA6300]' : 'text-[#462A71]'}`}
                                onClick={() => { navigate('/dashboard/my-profile'); setSidebarOpen(false); }}
                            >
                                <FaUser className="mr-2 w-5 h-5" /> Conta
                            </button>
                            <button
                                className={`flex items-center px-6 py-2 ${activeMenu === 'Alterar senha' ? 'text-[#FA6300]' : 'text-[#462A71]'}`}
                                onClick={() => { navigate('/dashboard/change-password'); setSidebarOpen(false); }}
                            >
                                <FaKey className="mr-2 w-5 h-5" /> Alterar senha
                            </button>
                            <button
                                className={`flex items-center px-6 py-2 ${activeMenu === 'Sair' ? 'text-[#FA6300]' : 'text-[#462A71]'}`}
                                onClick={() => { handleLogoutClick(); setSidebarOpen(false); }}
                            >
                                <ImExit className="mr-2 w-5 h-5" /> Sair
                            </button>
                        </nav>
                    </div>
                    {/* Close button (Mobile Only) */}
                    <div className="md:hidden p-4">
                        <button onClick={() => setSidebarOpen(false)} className="text-[#462A71]">
                            <FaTimes size={24} />
                        </button>
                    </div>
                </aside>

                {/* Main Content */}
                <div className="flex-1 p-4 md:p-8 ml-0 md:ml-48">
                    <div className="mb-3 border-b border-gray-400 flex items-center gap-3 w-full sm:justify-between">
                        <div className="md:hidden flex justify-between items-center mb-6">
                            <div className="md:hidden mt-3">
                                <button onClick={() => setSidebarOpen(true)} className="text-[#462A71]">
                                    <FaBars size={24} />
                                </button>
                            </div>
                        </div>
                        <div className='text-center sm:text-start mb-3'>
                            <h1 className="text-xl font-bold">Olá, {user?.nome}</h1>
                            <p className="text-sm text-gray-500">Aproveite todas as novidades que preparamos.</p>
                        </div>
                        <div className="hidden sm:block">
                            <Select
                                className='mb-2 hidden sm:block'
                                onChange={e => setBenefitSelected(e.target.value)}
                                value={benefitSelected}
                                variant='rounded'
                                label={'N° Benefício Selecionado'}
                            >
                                {user && user.beneficiosProdutos.map(nb => {
                                    return <option key={nb.codigoBeneficio} value={nb.codigoBeneficio}>{nb.codigoBeneficio}</option>
                                })}
                            </Select>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </React.Fragment>
    )
}

export default LayoutDashBoard